// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".normal-font[data-v-54dc8dc5]{font-weight:normal}", ""]);
// Exports
module.exports = exports;
